@if (edito) {
<section
    class="editorial-item"
    i18n-aria-label="@@hermes.accessibility.editorial-content"
    aria-label="Editorial content">
    <div class="editorial-snackable">
        <h-media-cta [media]="media" [token]="ctaToken"></h-media-cta>
        @if (!isContentEmpty) {
        <div
            class="editorial-item-body"
            [class.editorial-item-body-on]="edito.contentTitle && !edito.contentBody"
            [class.odd-editorial]="!isEvenEdito">
            @if (edito.contentTitle) {
            <h2 i18n class="grid-edito-title heading-2 display-light" [attr.role]="'heading'" aria-level="3">{{
                edito.contentTitle
            }}</h2>
            } @if (edito.contentBody) {
            <h-grid-edito-content [innerHTML]="edito.contentBody"></h-grid-edito-content>
            }
        </div>
        }
    </div>
</section>
}
